import AccessorySearchComponent from 'components/desktop/Accessory/Search/AccessorySearchComponent';

interface IProps {
	archive: boolean;
}

const AccessorySearchContainer = ({ archive }: IProps) => {
	return (
		<main className="container">
			<AccessorySearchComponent archive={archive} />
		</main>
	);
};

export default AccessorySearchContainer;
